import React from 'react';
import Loading from '../Loading/Loading';
import './card.css';

export const Card = ({ title, behaviors, onClick, backgroundColor, textColor, isLoading }) => {

  return (
    <button
      className='card'
      style={{ backgroundColor: backgroundColor, color: textColor }}
      onClick={onClick}
    >
      <h1 className='card__title'>{title}</h1>
      <ul className='card__list'>
        {behaviors.map((behavior, index) => (
          <li key={index} className='card__item'>{behavior}</li>
        ))}
      </ul>
    </button>
  )
}



// WEBPACK FOOTER //
// ./src/components/Card/index.js